import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=5317b765&scoped=true"
import script from "./Fallback.vue?vue&type=script&lang=js"
export * from "./Fallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317b765",
  null
  
)

export default component.exports